import './scss/main.scss';
import { config } from '@/config';
const isDevGtm = import.meta.env.VITE_GTM_MODE === 'development';

import Vue from 'vue';
import router from './app-router';
import components from './app-components';
import PortalVue from 'portal-vue';
import 'moment/dist/locale/ru';
import { checkBrowserType } from '@beautybox/core/utils/browserEnvironment';
checkBrowserType();

if (window.isWebView) {
    console.info('App is running inside of WebView');
}

import { createStore } from './app-store';
// vuex 3
export const store = createStore(config);
// pinia
import pinia from '@/stores';
// Plugins
import { vuetify } from '@beautybox/ui-kit/plugins/vuetify';
import VuePreview from 'vue-preview';
import VueClipboard from 'vue-clipboard2';
// Meta plugins
import VueHead from 'vue-head';
import VueMeta from 'vue-meta';
// google tag manager
import VueGtm from '@gtm-support/vue2-gtm';

import * as Sentry from '@sentry/vue';

import { setErrorHandler } from '@beautybox/core/mixins/errorHandler';
import mixins from '@beautybox/core/mixins.global';
import '@beautybox/core/filters.global';
import { setupVKID } from './vkid';

setErrorHandler(store);

Vue.config.productionTip = false;

// //Стратегия слияния миксина с validations и validations компонента
// let strategies = Vue.config.optionMergeStrategies;
// strategies.validations = strategies.methods;

//Решает проблему копирования текста из модального окна
VueClipboard.config.autoSetContainer = true;

import App from './app';

// Plugins
import Bus from '@beautybox/core/plugins/bus.plugin';
import request from '@beautybox/core/plugins/request';
import checkBreakpoint from '@/plugins/checkBreakpoint';
import toastMessage from '@beautybox/core/mixins/toastMessage';

Vue.use(Bus);
Vue.use(mixins);
Vue.use(VueMeta);
Vue.use(VueHead);
Vue.use(VuePreview);
Vue.use(VueClipboard);
Vue.use(PortalVue);
Vue.use(components);
Vue.use(toastMessage);
Vue.use(request, config);
Vue.use(checkBreakpoint);
Vue.use(VueGtm, {
    id: import.meta.env.VITE_GTM_ID,
    defer: false,
    compatibility: false,
    enabled: !isDevGtm,
    debug: true,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: true,
});

Sentry.init({
    Vue,
    dsn: 'https://2c2c7509a19a2a03b574a29131ef9481@sentry.beautybox-stage.ru/6',
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions

    tracePropagationTargets: [
        'localhost',
        /^https:\/\/beautybox-stage.ru\//,
        /^https:\/\/link.beautybox-stage.ru\//,
        /^https:\/\/beautybox.ru\//,
        /^https:\/\/link.beautybox.ru\//,
        /^https:\/\/tetradka.io\//,
        /^https:\/\/link.tetradka.io\//,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: import.meta.env.VITE_SENTRY_ENV,
});

setupVKID();

new Vue({
    store,
    pinia,
    router,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
